import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { FiMinus } from "react-icons/fi";
import "./faqs.css";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqs =[
    {
      question: "What is VATUG?",
      answer:
        "VATUG is a cutting-edge digital platform that connects charterers, shipowners, and brokers to simplify vessel chartering and sales. Our technology-driven solution ensures efficiency, transparency, and real-time decision-making in maritime logistics.",
    },
    {
      question: "How do I sign up?",
      answer:
        "You can create an account by clicking the 'Sign Up' button and filling out the registration form, including KYC. Choose your role as a Charterer, Shipowner, or Broker, and you'll gain access to tailored features.",
    },
    {
      question: "Can I try the platform before committing?",
      answer:
        "No, we don’t offer a demo for interested users to explore the platform’s capabilities.",
    },
    {
      question: "Is there a subscription fee?",
      answer: "Not yet, there is no fee.",
    },
    {
      question: "Can I use the platform on mobile devices?",
      answer:
        "Absolutely! VATUG is optimized for both desktop and mobile use, ensuring you can manage your operations anytime, anywhere.",
    },
    {
      question: "How does the real-time matching system work?",
      answer:
        "Our algorithm matches charterers with available vessels based on cargo requirements, location, and vessel specifications, ensuring quick and accurate results.",
    },
    {
      question: "Can I customize my searches?",
      answer:
        "Yes, our platform allows you to filter searches based on parameters like vessel type, size, capacity, location, and availability.",
    },
    {
      question: "Does the platform support contract management?",
      answer:
        "Yes, you can manage contracts directly on the platform. This includes storing, reviewing, and finalizing agreements in a secure environment.",
    },
    {
      question: "Can I track vessel movements through the platform?",
      answer:
        "Yes, our integrated tracking system provides real-time updates on vessel locations, helping you monitor progress and plan efficiently.",
    },
    {
      question: "Are there tools for price negotiation?",
      answer:
        "Our platform includes a built-in negotiation tool (for haggling), enabling charterers and owners to agree on terms directly within the platform.",
    },
    {
      question: "How secure is my data?",
      answer:
        "We use advanced encryption and secure servers to ensure your data is protected. User authentication and regular security updates safeguard all transactions and communications.",
    },
    {
      question: "Does the platform comply with maritime regulations?",
      answer:
        "Yes, we ensure that our platform aligns with international maritime regulations, offering tools to help users comply with evolving standards.",
    },
    {
      question: "Can I monitor environmental compliance through the platform?",
      answer:
        "Yes, features like emissions tracking and green compliance monitoring help users meet sustainability goals and adhere to regulations.",
    },
    {
      question: "What if I can't find a suitable vessel?",
      answer:
        "Our platform includes a 'Post a Requirement' feature that allows you to specify your needs, and our system will notify you as matching vessels become available.",
    },
    {
      question: "What should I do if I experience technical difficulties?",
      answer:
        "Our 24/7 support team is available via live chat, email, or phone to resolve any issues quickly.",
    },
    {
      question: "Can I provide feedback on the platform?",
      answer:
        "Yes, we welcome your input! Use the 'Feedback' option within your dashboard to share your thoughts and help us improve your experience.",
    },
    {
      question: "How are payments handled?",
      answer:
        "We offer secure payment gateways for transactions, ensuring quick and reliable processing for chartering or vessel sales.",
    },
    {
      question: "Are there transaction fees?",
      answer:
        "Transaction fees depend on the type of service and payment method used. Full details are available on our pricing page.",
    },
    {
      question: "Can I get invoices for my transactions?",
      answer:
        "Yes, the platform automatically generates invoices for every transaction, which you can download from your account dashboard.",
    },
    {
      question: "Can brokers use the platform?",
      answer:
        "Absolutely! Brokers can use the platform to facilitate deals, manage client relationships, and access valuable market insights.",
    },
    {
      question: "Does the platform offer analytics?",
      answer:
        "Yes, users can access analytics and reports on vessel performance, market trends, and transaction history to make informed decisions.",
    },
    {
      question: "Can I list multiple vessels on the platform?",
      answer:
        "Yes, vessel owners can list an unlimited number of vessels, complete with detailed specifications and availability dates.",
    },
    {
      question: "How do I know if my vessel is performing well in the market?",
      answer:
        "Our platform provides performance metrics and market insights to help you understand how your vessel compares in the industry.",
    },
  ];

  const handleToggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faqs-home">
      <div className="header">
        <h3>Frequently Asked Questions</h3>
      </div>
      <div className="Faq-container">
      <div className="questions">
        <ul>
          {faqs.map((faq, index) => (
            <li key={index} className={activeIndex === index ? "open" : ""}>
              <span onClick={() => handleToggleAnswer(index)}>
                <p>{faq.question}</p>
                <span className="icons">
                  {activeIndex === index ? <FiMinus /> : <AiOutlinePlus />}
                </span>
              </span>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
    </div>
  );
};

export default Faqs;
